import food from "../Svgs/Category/food.svg";
import travel from "../Svgs/Category/travel.svg";
import drink from "../Svgs/Category/drink.svg";
import bill from "../Svgs/Category/bill.svg";
import study from "../Svgs/Category/study.svg";
import cloth from "../Svgs/Category/cloth.svg";

const CategoryRenderData = [
  { name: "Food", id: "food", imgSrc: food, colorCode: "#FF5964" },
  { name: "Travel", id: "travel", imgSrc: travel, colorCode: "#38618C" },
  { name: "Drink", id: "drink", imgSrc: drink, colorCode: "#35A7FF" },
  { name: "Bill", id: "bill", imgSrc: bill, colorCode: "#C81B25" },
  { name: "Study", id: "study", imgSrc: study, colorCode: "#3BBC26" },
  { name: "Cloth", id: "cloth", imgSrc: cloth, colorCode: "#26BC98" },
];

export default CategoryRenderData;
